var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 19.5902C1.08333 11.3951 0 10.5366 0 7.49268C0 3.3561 3.54167 0 8 0C12.4167 0 16 3.3561 16 7.49268C16 10.5366 14.875 11.3951 8.79167 19.5902C8.41667 20.1366 7.54167 20.1366 7.16667 19.5902ZM8 10.6146C9.83333 10.6146 11.3333 9.24878 11.3333 7.49268C11.3333 5.77561 9.83333 4.37073 8 4.37073C6.125 4.37073 4.66667 5.77561 4.66667 7.49268C4.66667 9.24878 6.125 10.6146 8 10.6146Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoMenuIcon);
export default __webpack_public_path__ + "static/media/geo-menu-icon.614f3ccc785e2372fca3f15ebbb2e83c.svg";
export { ForwardRef as ReactComponent };